// ============================================================
// EXTRACT SPACE NAME UTILITY
// ============================================================

/**
 * Extrait le nom de l'espace depuis le priceBreakdown
 * Format attendu : "Base (Bureau Coworking RDC) (100000 × 1 pers × 3 mois)"
 * Retourne : "Bureau Coworking RDC"
 */
export function extractSpaceNameFromPriceBreakdown(metadata: any): string | null {
  if (!metadata || typeof metadata !== 'object') {
    console.log('[extractSpaceName] metadata absent ou invalide');
    return null;
  }

  const priceBreakdown = metadata.priceBreakdown;

  if (!Array.isArray(priceBreakdown) || priceBreakdown.length === 0) {
    console.log('[extractSpaceName] priceBreakdown absent ou vide');
    return null;
  }

  console.log('[extractSpaceName] priceBreakdown:', priceBreakdown);

  // Chercher le premier item qui contient "Base" dans le label (ligne de base de location)
  const baseItem = priceBreakdown.find(
    (item: any) => item.label && typeof item.label === 'string' && item.label.toLowerCase().startsWith('base'),
  );

  if (!baseItem) {
    console.log('[extractSpaceName] Aucun item "Base" trouvé');
    return null;
  }

  console.log('[extractSpaceName] baseItem trouvé:', baseItem);

  // Extraire le texte de la PREMIÈRE paire de parenthèses (nom de l'espace)
  // Format: "Base (Bureau Coworking RDC) (100000 × 1 pers × 3 mois)"
  const match = baseItem.label.match(/\(([^)]+)\)/);

  if (match && match[1]) {
    console.log('[extractSpaceName] Nom extrait:', match[1]);
    return match[1];
  }

  console.log('[extractSpaceName] Aucune parenthèse trouvée dans le label');
  return null;
}
